module.exports = __webpack_public_path__ + "img/boundary-error-event.9e053bcc.svg";